module.exports = __webpack_public_path__ + "static/media/single_column_black.6da3a039.svg";